export default __webpack_public_path__ + "static/media/0xc2132d05d31c914a87c6611c10748aeb04b58e8f.006177e6.png";